export default {
    LOAD_FILES(state, files) {
        state.items = files
    }
}